@if (!item().launch) {
  <a [routerLink]="item().url" [routerLinkActive]="'active'" >
    @if (item().icon) {
      <i class="material-icons menu-icon">{{item().icon}}</i>
    }
    @if (item().translate) {
      <span class="title">{{item().translate | translate}}</span>
    }
    @if (item().title && !item().translate) {
      <span class="title">{{item().title}}</span>
    }
    @if (item().badge) {
      <span class="badge" [ngStyle]="{'background-color': item().badge.bg, 'color': item().badge.fg}">
        {{item().badge.value}}
      </span>
    }
  </a>
}

@if (item().launch && item().type !== 'plan') {
  <a (click)="handle()">
    @if (item().icon) {
      <i class="material-icons menu-icon">{{item().icon}}</i>
    }
    @if (item().translate) {
      <span class="title">{{item().translate | translate}}</span>
    }
    @if (item().title && !item().translate) {
      <span class="title">{{item().title}}</span>
    }
    @if (item().badge) {
      <span class="badge" [ngStyle]="{'background-color': item().badge.bg, 'color': item().badge.fg}">
        {{item().badge.value}}
      </span>
    }
  </a>
}

@if (item().type === 'plan') {
  <a (click)="planUpload()">
    @if (item().icon) {
      <i class="material-icons menu-icon">{{item().icon}}</i>
    }
    @if (item().translate) {
      <span class="title">{{item().translate | translate}}</span>
    }
    @if (item().title && !item().translate) {
      <span class="title">{{item().title}}</span>
    }
    @if (item().badge) {
      <span class="badge" [ngStyle]="{'background-color': item().badge.bg, 'color': item().badge.fg}">
        {{item().badge.value}}
      </span>
    }
  </a>
}
